<div
  class="flex justify-between items-center mb-[22px] sticky top-0 !bg-[#dee2e6] p-6 !pl-[31px] !pr-[40px]"
>
  <div class="flex justify-start items-center gap-8 !bg-[#dee2e6]">
    <h3 class="project-plan">Project Plan</h3>
    <span
      class="!ml-[10px] bg-[#F4F4F4] px-[20px] rounded-[0.625rem] text-[#343A40] roboto font-semibold"
      >Risk Register</span
    >
  </div>
  <!-- Close Icon -->
  <div
    style="position: absolute; top: 10px; right: 36px; z-index: 50"
    (click)="closeDialog()"
  >
    <img
      src="assets/icons/cross-icon.svg"
      alt="cross icon"
      class="cursor-pointer !fixed"
    />
  </div>
</div>
<div class="flex justify-left">
  <div class="main-section mt-5">
    <div class="col-span-12">
      <form (keydown)="preventSubmit($event)" [formGroup]="form">
        <div class="p-6 !pt-0 !px-[40px]">
          <h5
            style="
              margin-bottom: 0px;
              color: #21252a;
              font-weight: 600;
              font-size: 1rem;
            "
          >
            Risk Description
          </h5>

          <div class="section-color p-6 pt-0 mb-0 pb-0">
            <div class="m-[50px] mb-[20px] ml-0 mt-[0px]">
              <app-rich-textEditor
                (contentChange)="addProjectOutline($event)"
                [resetEditor]="resetRichTextEditor"
              >
              </app-rich-textEditor>
              <mat-error
                *ngIf="
                  form.get('outline')?.hasError('required') &&
                  form.get('outline')?.touched
                "
              >
                Risk Description is required
              </mat-error>
            </div>
          </div>

          <div class="flex justify-left ml-[1px] mt-[0px] px-[30px] pb-[12px]">
            <mat-form-field appearance="outline" class="!w-[429px]">
              <mat-label>Risk Category</mat-label>
              <mat-select formControlName="riskCategory">
                <ng-container>
                  <mat-option
                    class="hover:!bg-[#fae8e1]"
                    *ngFor="let category of riskCategories"
                    [value]="category?.id"
                  >
                    {{ category?.name }}
                  </mat-option>
                </ng-container>
              </mat-select>
              <mat-error *ngIf="form.get('riskCategory')?.hasError('required')">
                Risk Category is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="flex justify-left ml-[1px] mt-[0px] px-[30px] pb-[12px]">
            <mat-form-field appearance="outline" class="!w-[429px]">
              <mat-label>Likelihood</mat-label>
              <mat-select formControlName="likelihood">
                <ng-container>
                  <mat-option
                    class="hover:!bg-[#fae8e1] !bg-gray-100"
                    disabled="true"
                    [value]=""
                    >Likelihood (1-5)</mat-option
                  >
                  <mat-option class="hover:!bg-[#fae8e1]" [value]="1"
                    >1 (minimum)</mat-option
                  >
                  <mat-option class="hover:!bg-[#fae8e1]" [value]="2"
                    >2</mat-option
                  >
                  <mat-option class="hover:!bg-[#fae8e1]" [value]="3"
                    >3</mat-option
                  >
                  <mat-option class="hover:!bg-[#fae8e1]" [value]="4"
                    >4</mat-option
                  >
                  <mat-option class="hover:!bg-[#fae8e1]" [value]="5"
                    >5 (maximum)</mat-option
                  >
                </ng-container>
              </mat-select>
              <mat-error *ngIf="form.get('likelihood')?.hasError('required')">
                Likelihood is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="flex justify-left ml-[1px] mt-[0px] px-[30px]">
            <mat-form-field appearance="outline" class="!w-[429px]">
              <mat-label>Impact</mat-label>
              <mat-select formControlName="impact">
                <ng-container>
                  <mat-option
                    class="hover:!bg-[#fae8e1] !bg-gray-100"
                    disabled="true"
                    [value]=""
                    >Impact (1-5)</mat-option
                  >
                  <mat-option class="hover:!bg-[#fae8e1]" [value]="1"
                    >1 (minimum)</mat-option
                  >
                  <mat-option class="hover:!bg-[#fae8e1]" [value]="2"
                    >2</mat-option
                  >
                  <mat-option class="hover:!bg-[#fae8e1]" [value]="3"
                    >3</mat-option
                  >
                  <mat-option class="hover:!bg-[#fae8e1]" [value]="4"
                    >4</mat-option
                  >
                  <mat-option class="hover:!bg-[#fae8e1]" [value]="5"
                    >5 (maximum)</mat-option
                  >
                </ng-container>
              </mat-select>
              <mat-error *ngIf="form.get('impact')?.hasError('required')">
                Impact is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="section-color p-6 mb-0 pb-0">
            <div class="m-[50px] mb-[20px] ml-0 mt-0">
              <label
                for=" mitifationStrategy"
                class="block text-sm font-medium text-gray-700 mr-[60px] mt-[10px] mb-[30px]"
              >
                Mitigation Strategy
              </label>
              <app-rich-textEditor
                (contentChange)="addMitigationStrategy($event)"
                [resetEditor]="resetRichTextEditor"
              >
              </app-rich-textEditor>

              <mat-error
                *ngIf="
                  form.get('mitigationStrategy')?.hasError('required') &&
                  form.get('mitigationStrategy')?.touched
                "
              >
                Mitigation Strategy is required
              </mat-error>
            </div>
          </div>

          <div class="flex justify-left ml-[1px] mt-[0px] px-[30px] pb-[12px]">
            <mat-form-field appearance="outline" class="!w-[429px]">
              <mat-label>Risk Owner</mat-label>
              <mat-select formControlName="riskOwner">
                <ng-container>
                  <mat-option
                    class="hover:!bg-[#fae8e1] !bg-gray-100"
                    disabled="true"
                    [value]=""
                    >Select Owner</mat-option
                  >
                  <mat-option
                    class="hover:!bg-[#fae8e1]"
                    *ngFor="let owner of riskOwners"
                    [value]="owner.name"
                  >
                    {{ owner.name }}
                  </mat-option>
                </ng-container>
              </mat-select>
              <mat-error *ngIf="form.get('riskOwner')?.hasError('required')">
                Risk Owner is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="flex justify-left mt-[0px] px-[30px] pb-[12px]">
            <mat-form-field appearance="outline" class="!w-[429px]">
              <mat-label>Target Resolution Date</mat-label>
              <input
                matInput
                [matDatepicker]="milestoneEndDate"
                type="text"
                formControlName="targetResolutionDate"
                placeholder="MM/DD/YYYY"
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="milestoneEndDate"
              ></mat-datepicker-toggle>
              <mat-datepicker #milestoneEndDate startView="year">
              </mat-datepicker>
              <mat-error
                *ngIf="form.get('targetResolutionDate')?.hasError('required')"
              >
                Target Resolution Date is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="flex justify-left ml-[1px] mt-[0px] p-[30px] pt-0">
            <mat-form-field appearance="outline" class="!w-[429px]">
              <mat-label>Status</mat-label>
              <mat-select formControlName="riskStatus">
                <ng-container>
                  <mat-option
                    class="hover:!bg-[#fae8e1] !bg-gray-100"
                    disabled="true"
                    [value]=""
                    >Select Status</mat-option
                  >
                  <mat-option
                    class="hover:!bg-[#fae8e1]"
                    *ngFor="let status of filterStatus(searchTerm)"
                    [value]="status"
                  >
                    {{ status }}
                  </mat-option>
                </ng-container>
              </mat-select>
              <mat-error *ngIf="form.get('riskStatus')?.hasError('required')">
                Status is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>
    <div
      class="btn-section card-container shadow-custom rounded-lg mb-0 sticky bottom-0"
      style="margin-top: 20px"
    >
      <button (click)="navigatetoPreviousPage()" type="button" class="back-btn">
        Back
      </button>
      <button class="next-btn" (click)="onSubmit()">
        <ng-container *ngIf="isLoading; else normalText">
          <div class="spinner"></div>
        </ng-container>
        <ng-template #normalText>Save</ng-template>
      </button>
    </div>
  </div>
</div>
